import qs from 'query-string';
import http from '@services/http';
import { Referrals } from '$admin/api/interfaces';

export const fetchReferrals = (data: Referrals.FetchReferrals.Request) => {
  const q = qs.stringify(data);
  return http.get<Referrals.FetchReferrals.Response>(`/admin/referrals?${q}`);
};